import { DurationDto } from "../statera"

export const convertDurationDtoToNumberOfSek = (durationDto: DurationDto | undefined) => {
  if (!durationDto) return 0
  const minutes = durationDto.minutes ? durationDto.minutes : 0
  const seconds = durationDto.seconds ? durationDto.seconds : 0
  return minutes * 60 + seconds
}
